// extracted by mini-css-extract-plugin
export var body = "_nt-8";
export var button = "_nt-0";
export var closeButton = "_nt-5";
export var content = "_nt-3";
export var empty = "_nt-f";
export var grid = "_nt-c";
export var header = "_nt-4";
export var icon = "_nt-1";
export var option = "_nt-d";
export var optionSelected = "_nt-e";
export var overlay = "_nt-2";
export var searchIcon = "_nt-a";
export var searchInput = "_nt-b";
export var searchWrapper = "_nt-9";
export var title = "_nt-6";
export var visuallyHidden = "_nt-7";